import { Button } from '@/lib/core/components/Button'

import styles from './StopsCountCell.module.css'
import { StopsCountCellProps } from './StopsCountCell.types'

export const StopsCountCell = ({ count, testId, onClick, ref }: StopsCountCellProps) => {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      className={styles.stopsCountCell}
      onClick={onClick}
      data-testid={testId}
    >
      {count}
    </Button>
  )
}
